import { render, staticRenderFns } from "./EstimatesOldSpecsSearch.vue?vue&type=template&id=24e5d350&"
import script from "./EstimatesOldSpecsSearch.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldSpecsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports